
import React from 'react';
import { ComparisonState, Theme } from '../types';
import { translations } from '../translations';

interface ThemeSwitcherProps {
  state: ComparisonState;
  applyTheme: (theme: Theme) => void;
  themeConfig: Record<Theme, { bg: string, border: string, text: string, radius: string, font: string }>;
}

export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ state, applyTheme, themeConfig }) => {
  const t = translations[state.language];

  return (
    <div className="w-full mb-12">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-4">
          <div className="h-px flex-1 bg-slate-800"></div>
          <h3 className="text-xs font-black uppercase tracking-[0.4em] text-indigo-400 px-4 whitespace-nowrap">
            {t.styles_themes}
          </h3>
          <div className="h-px flex-1 bg-slate-800"></div>
        </div>
        
        {/* With 15 themes, md:grid-cols-5 creates 3 clean rows of 5 buttons */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {(Object.keys(themeConfig) as Theme[]).map(theTheme => {
            const cfg = themeConfig[theTheme];
            const themeDisplayName = theTheme === 'dark_mode_2' ? 'Dark Mode 2.0' : (theTheme.charAt(0).toUpperCase() + theTheme.slice(1));
            const isActive = state.theme === theTheme;

            return (
              <button
                key={theTheme}
                onClick={() => applyTheme(theTheme)}
                className={`
                  relative h-14 px-4 text-[10px] font-black uppercase transition-all flex flex-col items-center justify-center gap-1 border-2 group
                  ${isActive ? 'scale-[1.02] shadow-[0_0_20px_rgba(99,102,241,0.2)] ring-2 ring-indigo-500/50 ring-offset-4 ring-offset-slate-950 opacity-100 z-10' : 'opacity-60 hover:opacity-100 hover:scale-[1.01]'}
                  ${cfg.bg} ${cfg.text} ${cfg.border} ${cfg.radius} ${cfg.font}
                `}
              >
                <span className="truncate w-full text-center">
                  {themeDisplayName}
                </span>
                <div className={`w-6 h-0.5 rounded-full bg-current transition-all ${isActive ? 'opacity-100 scale-x-110' : 'opacity-20 group-hover:opacity-40'}`} />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
